"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = numericRange;
var _utils = require("../utils");
var _lib = require("../lib");
function numericRange(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertNumber)(value);
  var message = options.message,
    min = options.min,
    max = options.max;
  var label = options.label || 'Field';
  var minProp = parseInt(min, 10) || 0;
  var maxProp = parseInt(max, 10) || 0;
  var defaultMsg = "".concat(label, " should be within ").concat(minProp, " to ").concat(maxProp);
  if ((0, _utils.checkValueExist)(max)) {
    (0, _utils.assertNumber)(max, 'max');
  } else {
    maxProp = value;
    defaultMsg = "".concat(label, " needs to be at least ").concat(minProp);
  }
  if ((0, _utils.checkValueExist)(min)) {
    (0, _utils.assertNumber)(min, 'min');
  } else {
    minProp = 0;
    defaultMsg = "".concat(label, " needs to be less than ").concat(maxProp);
  }
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  var isMin = value < minProp;
  var isMax = value > maxProp;
  if (isMax || isMin) {
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      isMin: isMin,
      isMax: isMax
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/numericRange.js
// module id = 1874
// module chunks = 0